/* eslint no-useless-escape: 0 */

function overwriteEmail() {
  /* @ngInject */
  let EMAIL_REGEXP =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
  let EMAIL_LOCAL_PART_REGEXP = /^(.){1,64}@/i;

  return {
    require: '?ngModel',
    link: function (scope, elm, attrs, ctrl) {
      // only apply the validator if ngModel is present and AngularJS has added the email validator
      if (ctrl && ctrl.$validators.email) {
        // this will overwrite the default AngularJS email validator
        ctrl.$validators.email = function (modelValue) {
          return (
            ctrl.$isEmpty(modelValue) ||
            (EMAIL_LOCAL_PART_REGEXP.test(modelValue) &&
              EMAIL_REGEXP.test(modelValue))
          );
        };
      }
    },
  };
}

export default overwriteEmail;
